import { useEffect, useRef, useState } from 'react';
import { useDeviceType } from './useDeviceType';

export const useScrollFadeIn = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { isDesktop } = useDeviceType();
  var threshold: number = 30
  if (isDesktop) {
    threshold = 60
  }

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current || isVisible) return;
      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      // 요소가 화면에 threshold px 이상 들어오면 표시
      if (rect.top < windowHeight - threshold) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // 초기 체크

    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return {
    ref,
    style: {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
      transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
    },
  };
};
